import SectionHeading from "./SectionHeading";
import { guideSteps } from "./data";

export default function Guide() {
  return (
    <section id="guide" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid items-center gap-8 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <SectionHeading
              eyebrow="三步直达 · 正版入口"
              title="从识别到进入，只需三步"
              desc="无论新老读者，建议每次进入都按此流程走一遍：先核对入口，再确认认证角标，最后开始浏览。步骤虽简单，却是避开仿冒站点的关键。"
            />
            <div className="mt-6 rounded-lg border border-accent-200 bg-accent-50 p-4 md:p-5">
              <p className="flex items-center gap-2 text-sm font-semibold text-accent-900">
                <i className="ri-lightbulb-flash-line"></i>
                小贴士
              </p>
              <p className="mt-1.5 text-xs leading-relaxed text-accent-800 md:text-sm">
                把本站「直达官方地址」按钮加入收藏书签。下次直接打开书签，即可始终从认证通道进入正版，省去手动核对的步骤。
              </p>
            </div>
          </div>

          <div className="grid gap-4 sm:grid-cols-3 lg:col-span-7">
            {guideSteps.map((step) => (
              <div
                key={step.step}
                className="flex flex-col rounded-lg border border-background-200 bg-background-100/60 p-5 transition-colors hover:border-primary-200"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className={step.icon + " text-xl"}></i>
                </span>
                <span className="mt-4 font-display text-xs tracking-[0.2em] text-primary-500">STEP {step.step}</span>
                <h3 className="mt-1 text-base font-semibold text-foreground-950">{step.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600 md:text-sm">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}